// All site copy, in both languages. Components read from here through useContent().
// MedHub is the software operator only — never describe it as insurance or as a medical provider.

const ar = {
  meta: {
    title: "MedHub — بلا طابور ولا ورق",
    description:
      "MedHub يربط مقدم الخدمة الطبية بعضوه وبالجهة التي ترعاه: المريض يطلب من بيته، ومقدم الخدمة يستلم الملف جاهزًا للتقديم.",
  },
  nav: {
    providers: "لمقدمي الخدمة",
    members: "للأعضاء",
    plans: "الباقات",
    organizations: "للجهات",
    capabilities: "كل المميزات",
    about: "من نحن",
    contact: "تواصل معنا",
    switchTo: "English",
  },
  hero: {
    title: "بلا طابور.\nبلا ورق.",
    text: "المريض يطلب من بيته، ومقدم الخدمة يستلم الملف جاهزًا للتقديم.",
    marketing: "لمقدمي الخدمة: انضم بأسعارك، والدفع يصل إلى حسابك مباشرة.",
    cta: "انضم كمقدم خدمة",
    journey: "▶ شاهد رحلة طلب",
    appsLabel: "للأعضاء: حمّل التطبيق",
  },
  providers: {
    title: "لمقدمي الخدمة",
    intro:
      "معامل، مراكز أشعة، عيادات — أي مقدم خدمة يتعامل مع مرضى التأمين الطبي يعرف هذه الرحلة.",
    beforeTitle: "اليوم",
    before: [
      "يصل المريض بالروشتة ويقف في الطابور حتى يأتي دوره",
      "يسلّم الورق وينتظر الموافقة، حتى لو كانت آلية",
      "موظف الاستقبال يعمل سكان للورق ويرفعه على موقع شركة التأمين",
      "انتظار الرد بقدر سرعة الإنترنت والموقع والنظام",
      "يُستدعى المريض للدفع إذا جاءت الموافقة والورق سليم",
      "دور جديد عند نافذة الخدمة",
      "النتائج على واتساب، أو رسالة لتحميلها، أو زيارة أخرى لاستلامها",
    ],
    afterTitle: "مع MedHub",
    journeyLink: "▶ شاهد الرحلة كاملة، مشهدًا مشهدًا",
    meetingLink: "▶ الاجتماع الأول: أسئلتك وإجاباتها في جلسة واحدة",
    after: [
      "المريض يطلب الخدمة من التطبيق ويرفع الروشتة وكارنيه التأمين من بيته",
      "الطلب يصلك في ملف مكتمل ومرتّب، بلا سكان ولا كتابة",
      "موظفك يقدّم الملف لشركة التأمين في دقيقة، والمريض يتابع الحالة لحظة بلحظة",
      "بعد الموافقة يدفع المريض بطريقته: أونلاين، أو بكود فوري، أو نقدًا عندك",
      "يحضر في موعده للخدمة فقط",
      "النتيجة تصله في التطبيق",
    ],
    benefitsTitle: "ما يحصل عليه مقدم الخدمة",
    benefits: [
      { t: "أسعارك أنت", d: "تنضم إلى MedHub بالأسعار التي تحددها." },
      {
        t: "الدفع إلى حسابك مباشرة",
        d: "عبر بوابة دفع مرخّصة، ولا تمر أموالك على MedHub.",
      },
      {
        t: "ملف جاهز للتقديم",
        d: "الروشتة والكارنيه والصور والبيانات مرتبة في مكان واحد.",
      },
      {
        t: "القرار لك",
        d: "قبول الرصيد المجاني أو النقاط لدى مركزك قرارك وحدك.",
      },
      {
        t: "مرضى جدد",
        d: "أعضاء MedHub يجدونك في التطبيق ويطلبون منك مباشرة.",
      },
      {
        t: "طوابير أقل",
        d: "المريض يحضر في موعده بعد الموافقة، لا قبلها.",
      },
    ],
    modelsTitle: "اختر طريقة التعاقد",
    modelsIntro: "لا نفرض طريقة واحدة على الجميع. اختر ما يناسب حجم عملك.",
    models: [
      {
        t: "اشتراك شهري",
        d: "قيمة ثابتة كل شهر، مهما كان عدد الطلبات.",
      },
      {
        t: "عمولة على كل عملية",
        d: "مبلغ ثابت يُقتطع تلقائيًا عند الدفع، والباقي يصل إلى حسابك مباشرة.",
      },
      {
        t: "النظام باسمك",
        d: "اشترِ النظام كاملًا ليعمل باسمك وعلامتك.",
      },
    ],
    submitTitle: "التقديم لشركات التأمين",
    submit: [
      {
        tag: "متاح الآن",
        t: "ملف جاهز للتقديم",
        d: "MedHub يجهّز الملف كاملًا، وموظفك يقدّمه على موقع شركة التأمين في دقيقة.",
      },
      {
        tag: "مع شركات التأمين الموافقة",
        t: "ربط مباشر",
        d: "الطلب يصل إلى شركة التأمين من النظام مباشرة، بلا موقع ولا رفع.",
      },
      {
        tag: "بموافقة مكتوبة من شركة التأمين",
        t: "تقديم آلي",
        d: "النظام يقدّم بحساب مركزك تلقائيًا، وإذا تعثّر يصل تنبيه فوري لموظفك ليكمل بنفسه.",
      },
    ],
    cta: "انضم إلى MedHub",
  },
  members: {
    featuresTitle: "للأعضاء",
    features: [
      {
        t: "اطلب من بيتك",
        d: "اختر مقدم الخدمة، وارفع الروشتة وكارنيه التأمين من التطبيق.",
      },
      {
        t: "تابع الموافقة",
        d: "اعرف حالة طلبك لحظة بلحظة، واحضر في موعدك بعد الموافقة.",
      },
      {
        t: "ادفع بطريقتك",
        d: "أونلاين، أو بكود فوري، أو نقدًا لدى مقدم الخدمة.",
      },
      {
        t: "أقرب مقدم خدمة",
        d: "ابحث عن المعامل ومراكز الأشعة والعيادات القريبة منك.",
      },
    ],
    startTitle: "ابدأ في أربع خطوات",
    steps: [
      {
        t: "سجّل",
        d: "اسمك وبريدك ورقم هاتفك، ثم كود التحقق — وتُفعَّل عضويتك الفردية مجانًا.",
      },
      {
        t: "أكمل ملفك الطبي",
        d: "فصيلة الدم والحساسية والأمراض والعمليات السابقة، وأضف أفراد أسرتك إلى حسابك.",
      },
      {
        t: "اطلب الخدمة",
        d: "اختر مقدم الخدمة، وارفع الروشتة وكارنيه التأمين إن وُجد.",
      },
      {
        t: "الموافقة والنتيجة",
        d: "تابع الموافقة من بيتك، وادفع، واحضر في موعدك، واستلم النتيجة في التطبيق.",
      },
    ],
  },
  plans: {
    title: "الباقات",
    note: "المزايا والخدمات والرصيد في كل باقة تحددها خطة جهتك — شركتك أو نقابتك أو شركة تأمينك.",
    corporateTag: "للجهات",
    corporateDetail: "التفاصيل حسب خطة جهتك.",
    platinum: { name: "بلاتينية", d: "أعلى مستوى من المزايا والخدمات." },
    titanium: { name: "تيتانيوم", d: "مستوى متقدم من المزايا والخدمات." },
    gold: { name: "ذهبية", d: "مستوى واسع من المزايا والخدمات." },
    bronze: { name: "برونزية", d: "المستوى الأساسي لباقات الجهات." },
    guest: {
      name: "زائر",
      tag: "بدون تسجيل",
      d: "تعرّف على مقدمي الخدمة والخدمات قبل إنشاء حسابك.",
    },
    primaryTitle: "الباقات الأساسية",
    silver: {
      name: "فضية",
      tag: "مجانية لكل عضو",
      d: "العضوية الفردية، تُفعَّل مجانًا بمجرد التسجيل وإكمال ملفك الطبي.",
    },
    gift: {
      name: "هدية",
      tag: "",
      d: "باقة تمنحها لك جهة أو مقدم خدمة، ومزاياها حسب الجهة المانحة.",
    },
  },
  organizations: {
    title: "لشركات التأمين والشركات والنقابات",
    intro:
      "كل مقدم خدمة ينضم يأتي بمرضاه، وكل مريض يأتي بجهته. MedHub منصة جاهزة لأي جهة تقدّم رعاية طبية لأعضائها.",
    audiences: [
      {
        t: "شركات التأمين الطبي",
        d: "طلبات تصلك من مقدمي الخدمة على MedHub في ملفات مكتملة، بدل الورق والسكان.",
      },
      {
        t: "الشركات التي تدير الرعاية الطبية لموظفيها",
        d: "أدِر رعاية موظفيك وأسرهم على نظام جاهز، بدل استئجار الأنظمة.",
      },
      {
        t: "النقابات",
        d: "عضويات لأعضائك وأسرهم، بباقات تحددها النقابة.",
      },
      {
        t: "شركات إدارة برامج الرعاية الصحية",
        d: "شغّلوا المطالبات والموافقات لعملائكم على نظام جاهز، باسمكم.",
      },
    ],
    modesTitle: "طريقتان للعمل",
    modes: [
      {
        t: "على MedHub",
        d: "تشغيل سحابي بلا إعداد: جهتك واحدة من الجهات على المنصة، وأعضاؤك يصلون إلى مقدمي الخدمة على MedHub من اليوم الأول.",
      },
      {
        t: "باسمكم",
        d: "النظام كاملًا باسمكم وعلامتكم، يعمل لكم وحدكم.",
      },
    ],
    withYouTitle: "وما يُصاغ مع جهتكم",
    withYouIntro: "قدرات نبنيها مع أول جهة تطلبها:",
    withYou: [
      "ربط مباشر بين نظامكم ونظام MedHub لإرسال الطلبات واستقبال الموافقات.",
      "تقديم آلي بحساب مقدم الخدمة، بموافقتكم المكتوبة.",
      "مقدمو الخدمة المتعاقدون مع جهتكم، بأسعار تعاقدكم معهم.",
      "حساب واحد للعضو يجمع عضوياته من أكثر من جهة.",
    ],
    cta: "تواصل معنا",
    meetingLink: "▶ الاجتماع الأول: الملكية والبيانات والتسليم والضمان",
  },
  demos: {
    common: {
      next: "الخطوة التالية ←",
      restart: "من البداية",
      note: "بيانات مُعدّة لهذه الصفحة للتوضيح.",
    },
    request: {
      title: "جرّب: طلب واحد، من موبايل العضو إلى مكتبك",
      intro:
        "اضغط الخطوة التالية وتابع الطلب على الجهتين معًا. غيّر المفاتيح قبل أن تبدأ لترى كل مسار.",
      service: "صورة دم كاملة",
      phoneTitle: "موبايل العضو",
      deskTitle: "مكتب مقدم الخدمة",
      waiting: "لم يبدأ الطلب بعد",
      fileTitle: "ملف الطلب",
      fileItems: {
        prescription: "الروشتة",
        card: "كارنيه التأمين",
        details: "بيانات العضو",
        medical: "الملف الطبي",
      },
      insured: "العضو عنده تأمين طبي",
      modeLabel: "طريقة التقديم لشركة التأمين",
      modes: {
        manual: "موظفك يقدّم (متاح الآن)",
        api: "ربط مباشر",
        auto: "تقديم آلي",
      },
      autoFails: "موقع شركة التأمين طلب كود تحقق",
      decisionLabel: "رد شركة التأمين",
      approve: "موافقة",
      reject: "رفض",
      visits: "مرات حضور العضو للمركز",
      queues: "طوابير قبل الخدمة",
      today: "اليوم: طابوران قبل الخدمة على الأقل، وقد يحتاج زيارة ثانية لاستلام النتيجة.",
      steps: {
        upload: {
          log: "العضو رفع الروشتة وكارنيه التأمين من بيته",
          phone: "أُرسل طلبك",
          desk: "ملف جديد، مكتمل",
        },
        uploadUninsured: {
          log: "العضو رفع الروشتة من بيته",
          phone: "أُرسل طلبك",
          desk: "ملف جديد، مكتمل",
        },
        manual: {
          log: "موظفك قدّم الملف على موقع شركة التأمين في دقيقة",
          phone: "قيد المراجعة لدى شركة التأمين",
          desk: "قُدّم — في انتظار الرد",
        },
        api: {
          log: "الطلب وصل إلى شركة التأمين من النظام مباشرة",
          phone: "قيد المراجعة لدى شركة التأمين",
          desk: "أُرسل تلقائيًا — في انتظار الرد",
        },
        auto: {
          log: "النظام بدأ التقديم بحساب مركزك تلقائيًا",
          phone: "قيد المراجعة لدى شركة التأمين",
          desk: "التقديم الآلي يعمل",
        },
        autoFail: {
          log: "تعثّر التقديم الآلي عند كود التحقق — وصل تنبيه لموظفك",
          phone: "قيد المراجعة لدى شركة التأمين",
          desk: "تنبيه: أكمل التقديم بنفسك",
        },
        autoFix: {
          log: "موظفك أكمل التقديم بنفسه",
          phone: "قيد المراجعة لدى شركة التأمين",
          desk: "قُدّم — في انتظار الرد",
        },
        approve: {
          log: "وافقت شركة التأمين",
          phone: "تمت الموافقة — اختر طريقة الدفع",
          desk: "موافقة ✓",
        },
        reject: {
          log: "رفضت شركة التأمين — والعضو عرف من بيته",
          phone: "مرفوض — ادفع كاملًا أو ألغِ الطلب، بلا مشوار",
          desk: "مرفوض",
        },
        confirm: {
          log: "مركزك أكّد الطلب بسعره",
          phone: "تم التأكيد — اختر طريقة الدفع",
          desk: "مؤكَّد",
        },
        pay: {
          log: "العضو دفع وحُدّد موعده",
          phone: "مدفوع — موعدك محدد",
          desk: "مدفوع ✓ — موعد محدد",
        },
        visit: {
          log: "العضو حضر في موعده، للخدمة فقط",
          phone: "أنت في المركز",
          desk: "العضو وصل في موعده",
        },
        result: {
          log: "النتيجة وصلت في تطبيق العضو",
          phone: "نتيجتك جاهزة في التطبيق",
          desk: "النتيجة أُرسلت",
        },
      },
    },
    claim: {
      title: "جرّب: مطالبة واحدة، وقواعد جهتك",
      intro: "حدّد قواعدك ثم غيّر المطالبة، وانظر متى يوافق النظام تلقائيًا ومتى يحوّلها لمراجع بشري.",
      member: "أحمد آدم",
      service: "أشعة رنين على الركبة",
      provider: "مركز أشعة — فرع التجمع",
      amount: "مبلغ المطالبة",
      autoLimit: "الموافقة التلقائية حتى",
      remaining: "المتبقي من حد العضو",
      duplicate: "نفس الخدمة لنفس العضو قبل 5 أيام",
      overPrice: "المبلغ أعلى من سعر التعاقد",
      checksTitle: "ما راجعه النظام",
      checks: {
        limit: "داخل حد العضو",
        auto: "تحت حد الموافقة التلقائية",
        duplicate: "لا تكرار",
        price: "مطابق لسعر التعاقد",
      },
      outcomes: {
        approved: "وافق النظام تلقائيًا",
        review: "حُوّلت لمراجع بشري",
        fraud: "أُوقفت: اشتباه تكرار — تنبيه للجهة",
        overLimit: "تتجاوز حد العضو — تنبيه ومراجعة",
      },
      nearLimit: "تنبيه: العضو اقترب من حده بعد هذه المطالبة",
      after: "المتبقي بعد الموافقة",
      reviewerApprove: "المراجع وافق",
      reviewerReject: "المراجع رفض",
      decidedApprove: "وافق المراجع — سُجّل من قرر ومتى",
      decidedReject: "رفض المراجع مع السبب — سُجّل من قرر ومتى",
      currency: "ج.م",
    },
    money: {
      title: "جرّب: أين تذهب الفلوس؟",
      intro: "حدّد سعرك وطريقة التعاقد، وانظر ما يدفعه العضو وما يصل إلى حسابك.",
      price: "سعرك للخدمة",
      modelLabel: "طريقة التعاقد",
      models: {
        subscription: "اشتراك شهري",
        commission: "عمولة على كل عملية",
        own: "النظام باسمك",
      },
      acceptBalance: "مركزك يقبل الرصيد المجاني",
      balance: "رصيد العضو المجاني",
      memberPays: "يدفع العضو",
      toProvider: "يصل إلى حسابك",
      toMedHub: "عمولة MedHub",
      discount: "الرصيد المجاني — خصم تقدّمه أنت",
      subscriptionNote: "الاشتراك الشهري ثابت، ولا يُقتطع شيء من هذه العملية.",
      commissionNote: "عمولة ثابتة للمثال تُقتطع تلقائيًا عند الدفع.",
      ownNote: "النظام ملكك، ولا يُقتطع شيء من أي عملية.",
      note: "أرقام توضيحية لهذه الصفحة. قيمة الاشتراك أو العمولة يُتفق عليها معك.",
      currency: "ج.م",
    },
    brand: {
      title: "جرّب: على MedHub أو باسمكم",
      intro: "اكتب اسم جهتك واختر لونها، وانظر كيف يرى العضو التطبيق في الطريقتين.",
      modeLabel: "طريقة العمل",
      onMedhub: "على MedHub",
      own: "باسمكم",
      name: "اسم جهتكم",
      defaultName: "نقابتكم",
      color: "لون علامتكم",
      member: "أحمد آدم",
      plan: "باقة ذهبية",
      sponsoredBy: "عضويتك من",
      cardTitle: "بطاقة العضوية",
      requests: "طلباتي",
      newRequest: "طلب جديد",
      note: "معاينة توضيحية للفكرة، لا لشكل التطبيق النهائي.",
    },
  },
  capabilities: {
    title: "كل ما في النظام",
    intro: "كل ما يقدّمه MedHub، مقسّمًا حسب من يستخدمه.",
    tabs: [
      {
        id: "provider",
        label: "مقدم الخدمة",
        items: [
          { t: "خدماتك وأسعارك", d: "ارفع قائمة خدماتك من ملف Excel، وحدّث أسعارك متى شئت، وصدّرها بضغطة." },
          { t: "كل فروعك في حساب واحد", d: "أضف فروعك مرة واحدة، ولكل فرع خدماته ومواعيده." },
          { t: "صندوق الطلبات", d: "كل طلب يصلك بملف مكتمل: اقبله، أو ارفضه بسبب، أو أنهِه." },
          { t: "التقديم لشركات التأمين", d: "ملف جاهز للتقديم الآن، وربط مباشر أو تقديم آلي مع الشركات الموافقة." },
          { t: "المواعيد", d: "حدّد موعد الحضور بعد الموافقة، فلا يقف أحد في طابور عندك." },
          { t: "النتيجة على الطلب نفسه", d: "ارفع نتيجة الزيارة فتصل إلى المريض في التطبيق فورًا." },
          { t: "الدفع إلى حسابك", d: "أونلاين أو بكود فوري أو نقدًا، والمستحقات تصل إلى حسابك مباشرة." },
          { t: "الرصيد والنقاط بقرارك", d: "أنت تقرر قبول الرصيد المجاني والنقاط لدى مركزك." },
          { t: "فاتورة باسم مركزك", d: "تصدر تلقائيًا مع كل طلب." },
          { t: "موظفوك وصلاحياتهم", d: "حسابات للاستقبال والمعمل والإدارة، كلٌّ بصلاحياته." },
          { t: "إحصائيات مركزك", d: "الطلبات والإيراد ونسبة الإنجاز، لكل فرع." },
          { t: "مطالباتك وحالتها", d: "كل مطالبة لدى الجهة بحالتها: مقدّمة، قيد المراجعة، مسوّاة — بلا اتصال ولا سؤال." },
          { t: "مراجعة قبل التقديم", d: "النظام يراجع الطلب على قواعد الجهة وحدود العضو قبل أن تقدّمه، فيقل الرفض." },
        ],
      },
      {
        id: "member",
        label: "العضو",
        items: [
          { t: "سجّل في دقيقة", d: "الاسم والبريد والهاتف ثم كود تحقق، والعضوية الفردية مجانية." },
          { t: "ملفك الطبي", d: "التشخيصات والأدوية والأمراض والعمليات وفصيلة الدم والحساسية، وسجل تحاليلك وأشعتك ومتابعتك." },
          { t: "رصيدك وحدودك", d: "اعرف رصيدك وحدود باقتك قبل أن تطلب، فلا مفاجآت." },
          { t: "اطلب من واتساب", d: "اطلب الخدمة وتابع طلبك من محادثة واتساب." },
          { t: "أسرتك في حساب واحد", d: "أضف أفراد أسرتك، ولكل فرد ملفه وطلباته." },
          { t: "اعرف السعر قبل أن تطلب", d: "الإجمالي بعد مزايا باقتك يظهر قبل التأكيد." },
          { t: "أكثر من خدمة في طلب واحد", d: "سلة واحدة لتحاليل وأشعة متعددة عند مقدم خدمة واحد." },
          { t: "ارفع الروشتة والكارنيه", d: "من الكاميرا أو من معرض الصور." },
          { t: "تابع لحظة بلحظة", d: "إشعارات في التطبيق وبالرسائل وبالبريد مع كل تغيير في طلبك." },
          { t: "ادفع بطريقتك", d: "أونلاين أو بكود فوري أو نقدًا، وتقدر تغيّر الطريقة قبل الدفع." },
          { t: "نتائجك في مكان واحد", d: "كل نتيجة تصلك في التطبيق وتبقى في سجلك." },
          { t: "فاتورة لكل طلب", d: "تجدها في التطبيق متى احتجتها." },
          { t: "عضوية جهتك بكود", d: "فعّل عضويتك من شركتك أو نقابتك بالكود الذي تمنحه لك." },
          { t: "بلغتك، وبيانات تحت يدك", d: "عربي وإنجليزي، وتحذف حسابك بنفسك متى شئت." },
        ],
      },
      {
        id: "organization",
        label: "الجهة",
        items: [
          { t: "لوحة لجهتك", d: "مسؤول من جهتك يدير أعضاءها من لوحة خاصة بها." },
          { t: "باقاتك أنت", d: "الرصيد الافتتاحي والمزايا والخدمات في كل باقة تحددها جهتك." },
          { t: "الأسرة ضمن الباقة", d: "اسمح بإضافة الأسرة، وحدّد رصيد كل فرد." },
          { t: "أكواد العضوية", d: "وزّع أكوادًا على أعضائك يفعّلون بها عضويتهم بأنفسهم." },
          { t: "طلبات العضوية", d: "راجع كل طلب، ووافق عليه أو ارفضه." },
          { t: "بيانات التعاقد", d: "مدة العقد وشروط الدفع وملف الاتفاق في مكان واحد." },
          { t: "تقارير أعضائك", d: "الطلبات والخدمات شهريًا، مع تصدير Excel." },
          { t: "دورة المطالبات كاملة", d: "تسجيل ومراجعة وتدقيق وحالات وتسوية وتقارير، على نظامكم." },
          { t: "محرك قواعد للموافقات", d: "قواعدكم تحدد: ما يطابقها يُوافَق عليه تلقائيًا، والاستثناء يذهب لمراجعة بشرية." },
          { t: "كشف التكرار والتحايل", d: "نفس الخدمة لنفس العضو في مدة قصيرة، أو نفس الروشتة مرتين ولو تغيّر اسم الخدمة." },
          { t: "الفاتورة مقابل سعر التعاقد", d: "أي فاتورة أعلى من السعر المتفق عليه تُعلَّم تلقائيًا." },
          { t: "خطاب الموافقة الأحدث فقط", d: "صدور خطاب موافقة جديد يلغي القديم تلقائيًا." },
          { t: "تنبيهات الحدود وسوء الاستخدام", d: "عضو يقترب من حده أو يتجاوزه، أو استخدام غير معتاد، يصلك تنبيه فوري." },
          { t: "ميزانيات", d: "ميزانية لكل موظف وإدارة ونوع خدمة، ومتابعة الاستهلاك وتنبيه عند التجاوز." },
        ],
      },
      {
        id: "admin",
        label: "إدارة النظام",
        items: [
          { t: "لوحة مؤشرات", d: "الأعضاء ومقدمو الخدمة وطلبات الشهر ونسبة الإنجاز والعضويات الجديدة." },
          { t: "تقارير شهرية", d: "بالأرقام، مع تصدير Excel." },
          { t: "صلاحيات دقيقة", d: "أكثر من 140 صلاحية تُوزَّع على الأدوار، لكل شخص ما يخصه فقط." },
          { t: "سجل كل عملية", d: "كل تغيير في طلب أو دفع أو عضوية مسجّل: من فعله ومتى." },
          { t: "مقدمو الخدمة والجهات", d: "أضف مركزًا بفروعه وخدماته، وجهة بباقاتها، من شاشة واحدة." },
          { t: "بيانات مرجعية", d: "التصنيفات والأمراض والمناطق، تُدار من لوحة التحكم." },
          { t: "إشعارات لكل حدث", d: "بريد ورسائل وإشعارات موبايل، بالعربي والإنجليزي." },
          { t: "بوابات دفع مرخّصة", d: "فوري وPaymob، والفلوس لا تمر على MedHub." },
          { t: "عربي وإنجليزي بالكامل", d: "التطبيق ولوحة التحكم، بكل شاشاتهما." },
          { t: "بوابة لكل طرف", d: "للعضو ومقدم الخدمة والطبيب والمستشفى والصيدلية والجهة والإدارة." },
          { t: "استضافة بطريقتكم", d: "على السحابة، أو على خوادم جهتكم." },
          { t: "دخول موحّد", d: "بحسابات جهتكم نفسها: Active Directory وSAML وOAuth." },
          { t: "نقل بياناتكم", d: "تحليل ثم تنظيف ثم تشغيل بالتوازي ثم انتقال نهائي، بلا توقف للعمل." },
          { t: "نسخ احتياطي وخادم بديل", d: "نسخ تلقائية، وخادم بديل يتولى العمل عند أي عطل." },
          { t: "تشفير وحماية البيانات", d: "تشفير أثناء النقل والتخزين، ومصمَّم وفق قانون حماية البيانات الشخصية المصري." },
          { t: "ذكاء اصطناعي في الإدارة", d: "قراءة الروشتة، وكشف التكرار، ومقارنة الفواتير — للإدارة لا للعلاج." },
        ],
      },
    ],
  },
  about: {
    title: "من نحن",
    paras: [
      "MedHub منصة من ZRS Hubtech، شركة برمجيات مصرية. نبني الأنظمة التي تربط مقدم الخدمة الطبية بعضوه وبالجهة التي ترعاه.",
      "دورنا هو البرنامج فقط: MedHub ليست شركة تأمين، ولا تقدّم خدمة طبية، ولا تحتفظ بأموال أحد. مقدم الخدمة يقدّم الخدمة ويحدد أسعاره ويستلم مستحقاته، والجهة الراعية تحدد مزايا أعضائها.",
    ],
    leadStrong: "يدًا بيد في رحلتك الصحية، ",
    lead: "من الطلب إلى النتيجة، بلا طابور ولا ورق.",
  },
  contact: {
    title: "تواصل معنا",
    company: "ZRS Hubtech",
    address:
      "المبنى الإداري رقم 5 - زيزينيا ريزورت - التجمع الخامس - القاهرة الجديدة - مصر",
  },
  footer: {
    rights: "ZRS Hubtech",
  },
};

export type Content = typeof ar;

const en: Content = {
  meta: {
    title: "MedHub — No queue. No paperwork.",
    description:
      "MedHub connects the medical service provider, its member and the organisation behind them: the patient requests from home, and the provider receives a file ready to submit.",
  },
  nav: {
    providers: "Providers",
    members: "Members",
    plans: "Plans",
    organizations: "Organisations",
    capabilities: "All features",
    about: "About",
    contact: "Contact",
    switchTo: "العربية",
  },
  hero: {
    title: "No queue.\nNo paperwork.",
    text: "The patient requests from home. The provider receives a file ready to submit.",
    marketing:
      "For providers: join at your own prices — payments go straight to your account.",
    cta: "Join as a provider",
    journey: "▶ Watch one request's journey",
    appsLabel: "For members: get the app",
  },
  providers: {
    title: "For providers",
    intro:
      "Labs, radiology centres, clinics — every provider that serves insured patients knows this journey.",
    beforeTitle: "Today",
    before: [
      "The patient arrives with the prescription and queues until their turn",
      "Hands in the papers and waits for approval, even when it's automatic",
      "The receptionist scans the papers and uploads them to the insurer's portal",
      "The reply takes as long as the connection, the portal and the system allow",
      "The patient is called to pay if approval comes back and the papers are in order",
      "Another queue at the service window",
      "Results on WhatsApp, a download link, or another visit to collect them",
    ],
    afterTitle: "With MedHub",
    journeyLink: "▶ Watch the whole journey, scene by scene",
    meetingLink: "▶ The first meeting: your questions answered in one session",
    after: [
      "The patient requests the service in the app and uploads the prescription and insurance card from home",
      "The request reaches you as a complete, ordered file — no scanning, no typing",
      "Your staff submit it to the insurer in a minute, and the patient tracks it live",
      "Once approved, the patient pays their way: online, a Fawry code, or cash at your desk",
      "They come in at their appointment, for the service only",
      "The result reaches them in the app",
    ],
    benefitsTitle: "What the provider gets",
    benefits: [
      { t: "Your prices", d: "Join MedHub at the prices you set." },
      {
        t: "Paid straight to your account",
        d: "Through a licensed payment gateway — your money never passes through MedHub.",
      },
      {
        t: "A file ready to submit",
        d: "Prescription, card, images and details in one place, in order.",
      },
      {
        t: "Your call",
        d: "Whether your facility accepts free balance or points is up to you alone.",
      },
      {
        t: "New patients",
        d: "MedHub members find you in the app and request from you directly.",
      },
      {
        t: "Shorter queues",
        d: "Patients arrive at their appointment after approval, not before it.",
      },
    ],
    modelsTitle: "Choose how you work with us",
    modelsIntro:
      "We don't force one model on everyone. Pick the one that fits the size of your business.",
    models: [
      {
        t: "Monthly subscription",
        d: "A fixed amount each month, however many requests you receive.",
      },
      {
        t: "Per-transaction commission",
        d: "A fixed amount taken automatically at payment; the rest goes straight to your account.",
      },
      {
        t: "The system, under your name",
        d: "Buy the complete system to run under your own name and brand.",
      },
    ],
    submitTitle: "Submitting to insurers",
    submit: [
      {
        tag: "Available now",
        t: "A file ready to submit",
        d: "MedHub prepares the complete file; your staff submit it on the insurer's portal in a minute.",
      },
      {
        tag: "With insurers who agree",
        t: "Direct integration",
        d: "The request reaches the insurer straight from the system — no portal, no uploading.",
      },
      {
        tag: "With the insurer's written consent",
        t: "Automatic submission",
        d: "The system submits under your facility's account; if it stalls, your staff are alerted at once to finish it.",
      },
    ],
    cta: "Join MedHub",
  },
  members: {
    featuresTitle: "For members",
    features: [
      {
        t: "Request from home",
        d: "Choose the provider and upload your prescription and insurance card in the app.",
      },
      {
        t: "Track the approval",
        d: "See your request's status live, and come in at your appointment once approved.",
      },
      {
        t: "Pay your way",
        d: "Online, with a Fawry code, or cash at the provider.",
      },
      {
        t: "Nearest provider",
        d: "Find the labs, radiology centres and clinics near you.",
      },
    ],
    startTitle: "Get started in four steps",
    steps: [
      {
        t: "Sign up",
        d: "Your name, email and phone number, then the verification code — and your individual membership is activated free.",
      },
      {
        t: "Complete your medical file",
        d: "Blood type, allergies, conditions and past operations — and add your family to your account.",
      },
      {
        t: "Request a service",
        d: "Choose the provider and upload your prescription, plus your insurance card if you have one.",
      },
      {
        t: "Approval and results",
        d: "Track the approval from home, pay, come in at your appointment, and get the result in the app.",
      },
    ],
  },
  plans: {
    title: "Plans",
    note: "The benefits, services and balance in every plan are set by your organisation's plan — your employer, your syndicate or your insurer.",
    corporateTag: "Organisations",
    corporateDetail: "Details depend on your organisation's plan.",
    platinum: { name: "Platinum", d: "The highest level of benefits and services." },
    titanium: { name: "Titanium", d: "An advanced level of benefits and services." },
    gold: { name: "Gold", d: "A broad level of benefits and services." },
    bronze: { name: "Bronze", d: "The entry level of organisation plans." },
    guest: {
      name: "Guest",
      tag: "No sign-up",
      d: "Browse the providers and services before creating your account.",
    },
    primaryTitle: "Primary plans",
    silver: {
      name: "Silver",
      tag: "Free for every member",
      d: "The individual membership — activated free once you sign up and complete your medical file.",
    },
    gift: {
      name: "Gift",
      tag: "",
      d: "A plan granted to you by an organisation or a provider; its benefits depend on who grants it.",
    },
  },
  organizations: {
    title: "For insurers, companies and syndicates",
    intro:
      "Every provider that joins brings its patients, and every patient brings their organisation. MedHub is a ready platform for any organisation that provides medical care to its members.",
    audiences: [
      {
        t: "Medical insurers",
        d: "Requests reach you from providers on MedHub as complete files, instead of paper and scans.",
      },
      {
        t: "Companies that run their staff's medical care",
        d: "Manage care for your employees and their families on a ready system, instead of renting one.",
      },
      {
        t: "Syndicates",
        d: "Memberships for your members and their families, on plans the syndicate sets.",
      },
      {
        t: "Healthcare programme administrators (TPAs)",
        d: "Run claims and approvals for your clients on a ready system, under your name.",
      },
    ],
    modesTitle: "Two ways to run it",
    modes: [
      {
        t: "On MedHub",
        d: "Cloud-hosted with no setup: your organisation is one of many on the platform, and your members reach the providers on MedHub from day one.",
      },
      {
        t: "Under your name",
        d: "The complete system under your own name and brand, running for you alone.",
      },
    ],
    withYouTitle: "Built with you",
    withYouIntro: "Capabilities we build with the first organisation that asks:",
    withYou: [
      "Direct integration between your system and MedHub to send requests and receive approvals.",
      "Automatic submission under the provider's account, with your written consent.",
      "The providers your organisation contracts with, at the prices you agreed with them.",
      "One member account holding memberships from more than one organisation.",
    ],
    cta: "Contact us",
    meetingLink: "▶ The first meeting: ownership, data, delivery and warranty",
  },
  demos: {
    common: {
      next: "Next step →",
      restart: "Start over",
      note: "Sample data prepared for this page.",
    },
    request: {
      title: "Try it: one request, from the member's phone to your desk",
      intro:
        "Press next step and follow the request on both sides at once. Change the switches before you start to see every path.",
      service: "Complete blood count",
      phoneTitle: "Member's phone",
      deskTitle: "Provider's desk",
      waiting: "The request hasn't started yet",
      fileTitle: "Request file",
      fileItems: {
        prescription: "Prescription",
        card: "Insurance card",
        details: "Member details",
        medical: "Medical file",
      },
      insured: "The member has medical insurance",
      modeLabel: "How it's submitted to the insurer",
      modes: {
        manual: "Your staff submit (available now)",
        api: "Direct integration",
        auto: "Automatic submission",
      },
      autoFails: "The insurer's portal asked for a verification code",
      decisionLabel: "Insurer's reply",
      approve: "Approve",
      reject: "Reject",
      visits: "Member visits to the centre",
      queues: "Queues before the service",
      today: "Today: at least two queues before the service, and maybe a second visit to collect the result.",
      steps: {
        upload: {
          log: "The member uploaded the prescription and insurance card from home",
          phone: "Request sent",
          desk: "New file, complete",
        },
        uploadUninsured: {
          log: "The member uploaded the prescription from home",
          phone: "Request sent",
          desk: "New file, complete",
        },
        manual: {
          log: "Your staff submitted the file on the insurer's portal in a minute",
          phone: "Under review by the insurer",
          desk: "Submitted — awaiting reply",
        },
        api: {
          log: "The request reached the insurer straight from the system",
          phone: "Under review by the insurer",
          desk: "Sent automatically — awaiting reply",
        },
        auto: {
          log: "The system started submitting under your facility's account",
          phone: "Under review by the insurer",
          desk: "Automatic submission running",
        },
        autoFail: {
          log: "Automatic submission stalled at the verification code — your staff were alerted",
          phone: "Under review by the insurer",
          desk: "Alert: finish the submission yourself",
        },
        autoFix: {
          log: "Your staff finished the submission",
          phone: "Under review by the insurer",
          desk: "Submitted — awaiting reply",
        },
        approve: {
          log: "The insurer approved",
          phone: "Approved — choose how to pay",
          desk: "Approved ✓",
        },
        reject: {
          log: "The insurer rejected — and the member found out at home",
          phone: "Rejected — pay in full or cancel, no trip needed",
          desk: "Rejected",
        },
        confirm: {
          log: "Your centre confirmed the request at its price",
          phone: "Confirmed — choose how to pay",
          desk: "Confirmed",
        },
        pay: {
          log: "The member paid and got an appointment",
          phone: "Paid — appointment set",
          desk: "Paid ✓ — appointment set",
        },
        visit: {
          log: "The member came in at their appointment, for the service only",
          phone: "You're at the centre",
          desk: "Member arrived on time",
        },
        result: {
          log: "The result reached the member's app",
          phone: "Your result is ready in the app",
          desk: "Result sent",
        },
      },
    },
    claim: {
      title: "Try it: one claim, your organisation's rules",
      intro: "Set your rules, then change the claim, and see when the system approves automatically and when it goes to a human reviewer.",
      member: "Ahmed Adam",
      service: "Knee MRI",
      provider: "Radiology centre — New Cairo branch",
      amount: "Claim amount",
      autoLimit: "Auto-approve up to",
      remaining: "Member's remaining limit",
      duplicate: "Same service for the same member 5 days ago",
      overPrice: "Amount above the contracted price",
      checksTitle: "What the system checked",
      checks: {
        limit: "Within the member's limit",
        auto: "Below the auto-approval limit",
        duplicate: "No duplicate",
        price: "Matches the contracted price",
      },
      outcomes: {
        approved: "Approved automatically",
        review: "Sent to a human reviewer",
        fraud: "Held: suspected duplicate — organisation alerted",
        overLimit: "Exceeds the member's limit — alert and review",
      },
      nearLimit: "Alert: the member is close to their limit after this claim",
      after: "Remaining after approval",
      reviewerApprove: "Reviewer approves",
      reviewerReject: "Reviewer rejects",
      decidedApprove: "Approved by the reviewer — who decided and when is logged",
      decidedReject: "Rejected by the reviewer with a reason — who decided and when is logged",
      currency: "EGP",
    },
    money: {
      title: "Try it: where does the money go?",
      intro: "Set your price and contract model, and see what the member pays and what reaches your account.",
      price: "Your price for the service",
      modelLabel: "Contract model",
      models: {
        subscription: "Monthly subscription",
        commission: "Per-transaction commission",
        own: "The system, under your name",
      },
      acceptBalance: "Your centre accepts free balance",
      balance: "Member's free balance",
      memberPays: "Member pays",
      toProvider: "Reaches your account",
      toMedHub: "MedHub commission",
      discount: "Free balance — a discount you give",
      subscriptionNote: "The monthly subscription is fixed; nothing is taken from this transaction.",
      commissionNote: "A sample fixed commission, taken automatically at payment.",
      ownNote: "You own the system; nothing is taken from any transaction.",
      note: "Illustrative figures for this page. The subscription or commission is agreed with you.",
      currency: "EGP",
    },
    brand: {
      title: "Try it: on MedHub or under your name",
      intro: "Type your organisation's name and pick its colour, and see how members see the app either way.",
      modeLabel: "How you run it",
      onMedhub: "On MedHub",
      own: "Under your name",
      name: "Your organisation's name",
      defaultName: "Your syndicate",
      color: "Your brand colour",
      member: "Ahmed Adam",
      plan: "Gold plan",
      sponsoredBy: "Membership from",
      cardTitle: "Membership card",
      requests: "My requests",
      newRequest: "New request",
      note: "An illustration of the idea, not the final app design.",
    },
  },
  capabilities: {
    title: "Everything in the system",
    intro: "Everything MedHub offers, grouped by who uses it.",
    tabs: [
      {
        id: "provider",
        label: "Provider",
        items: [
          { t: "Your services and prices", d: "Upload your service list from an Excel file, update prices any time, and export in one click." },
          { t: "All your branches, one account", d: "Add your branches once; each has its own services and hours." },
          { t: "Request inbox", d: "Every request arrives as a complete file: accept it, reject it with a reason, or complete it." },
          { t: "Submitting to insurers", d: "A file ready to submit today; direct integration or automatic submission with insurers who agree." },
          { t: "Appointments", d: "Set the visit time after approval, so nobody queues at your centre." },
          { t: "Results on the request itself", d: "Upload the visit result and it reaches the patient's app at once." },
          { t: "Paid to your account", d: "Online, Fawry code or cash — your dues go straight to your account." },
          { t: "Balance and points, your call", d: "You decide whether your centre accepts free balance and points." },
          { t: "Invoices in your name", d: "Issued automatically with every request." },
          { t: "Your staff and their permissions", d: "Accounts for reception, lab and management, each with its own permissions." },
          { t: "Your centre's analytics", d: "Requests, revenue and completion rate, per branch." },
          { t: "Your claims and their status", d: "Every claim with the organisation and where it stands: submitted, under review, settled — no calls, no chasing." },
          { t: "Checked before you submit", d: "The system checks the request against the organisation's rules and the member's limits before you submit, so fewer get rejected." },
        ],
      },
      {
        id: "member",
        label: "Member",
        items: [
          { t: "Sign up in a minute", d: "Name, email and phone, then a verification code — and the individual membership is free." },
          { t: "Your medical file", d: "Diagnoses, medications, conditions, operations, blood type and allergies, plus your test, scan and follow-up history." },
          { t: "Your balance and limits", d: "Know your balance and plan limits before you request — no surprises." },
          { t: "Request on WhatsApp", d: "Request a service and follow it from a WhatsApp chat." },
          { t: "Your family, one account", d: "Add your family; each person has their own file and requests." },
          { t: "Know the price before you request", d: "The total after your plan's benefits shows before you confirm." },
          { t: "Several services, one request", d: "One cart for multiple tests and scans at one provider." },
          { t: "Upload prescription and card", d: "From the camera or your photo gallery." },
          { t: "Follow every step", d: "Notifications in the app, by SMS and by email whenever your request changes." },
          { t: "Pay your way", d: "Online, Fawry code or cash — and you can switch before paying." },
          { t: "Your results in one place", d: "Every result reaches the app and stays in your history." },
          { t: "An invoice for every request", d: "Always in the app when you need it." },
          { t: "Your organisation's membership by code", d: "Activate your membership from your employer or syndicate with the code they give you." },
          { t: "Your language, your data", d: "Arabic and English, and you can delete your account yourself any time." },
        ],
      },
      {
        id: "organization",
        label: "Organisation",
        items: [
          { t: "A dashboard for your organisation", d: "An admin from your organisation manages its members from its own dashboard." },
          { t: "Your own plans", d: "Opening balance, benefits and services in every plan are set by your organisation." },
          { t: "Family within the plan", d: "Allow family members, and set each one's balance." },
          { t: "Membership codes", d: "Hand out codes your members use to activate their membership themselves." },
          { t: "Membership requests", d: "Review each request, and approve or reject it." },
          { t: "Contract details", d: "Contract term, payment terms and the agreement file in one place." },
          { t: "Reports on your members", d: "Requests and services each month, with Excel export." },
          { t: "The full claims cycle", d: "Registration, review, audit, status, settlement and reports — on your system." },
          { t: "A rules engine for approvals", d: "Your rules decide: what matches is approved automatically, exceptions go to a human reviewer." },
          { t: "Duplicate and fraud detection", d: "The same service for the same member within a short time, or the same prescription twice even under a different service name." },
          { t: "Invoice versus contracted price", d: "Any invoice above the agreed price is flagged automatically." },
          { t: "Only the latest approval letter", d: "Issuing a new approval letter cancels the old one automatically." },
          { t: "Limit and misuse alerts", d: "A member nearing or exceeding their limit, or unusual usage, triggers an instant alert." },
          { t: "Budgets", d: "A budget per employee, department and service type, with usage tracking and overrun alerts." },
        ],
      },
      {
        id: "admin",
        label: "System admin",
        items: [
          { t: "Metrics dashboard", d: "Members, providers, this month's requests, completion rate and new memberships." },
          { t: "Monthly reports", d: "In numbers, with Excel export." },
          { t: "Fine-grained permissions", d: "More than 140 permissions assigned to roles — everyone sees only what's theirs." },
          { t: "A log of every action", d: "Every change to a request, payment or membership is recorded: who and when." },
          { t: "Providers and organisations", d: "Add a centre with its branches and services, or an organisation with its plans, from one screen." },
          { t: "Reference data", d: "Categories, conditions and locations, managed from the dashboard." },
          { t: "Notifications for every event", d: "Email, SMS and mobile push, in Arabic and English." },
          { t: "Licensed payment gateways", d: "Fawry and Paymob — the money never passes through MedHub." },
          { t: "Fully Arabic and English", d: "The app and the dashboard, every screen." },
          { t: "A portal for every party", d: "Member, provider, doctor, hospital, pharmacy, organisation and admin." },
          { t: "Hosting your way", d: "In the cloud, or on your organisation's own servers." },
          { t: "Single sign-on", d: "With your organisation's own accounts: Active Directory, SAML and OAuth." },
          { t: "Moving your data", d: "Analysis, clean-up, a parallel run, then cut-over — without stopping work." },
          { t: "Backups and a standby server", d: "Automatic backups, and a standby server that takes over on any failure." },
          { t: "Encryption and data protection", d: "Encrypted in transit and at rest, and designed around Egypt's Personal Data Protection Law." },
          { t: "AI for administration", d: "Reading prescriptions, spotting duplicates, comparing invoices — for administration, not treatment." },
        ],
      },
    ],
  },
  about: {
    title: "About",
    paras: [
      "MedHub is a platform by ZRS Hubtech, an Egyptian software company. We build the systems that connect a medical service provider with its member and the organisation behind them.",
      "Our role is the software only: MedHub is not an insurer, does not provide medical services, and holds no one's money. The provider delivers the service, sets its prices and receives its dues; the sponsoring organisation sets its members' benefits.",
    ],
    leadStrong: "Hand in hand on your health journey, ",
    lead: "from request to result — no queue, no paperwork.",
  },
  contact: {
    title: "Contact",
    company: "ZRS Hubtech",
    address:
      "Administrative Building No. 5 - Zizinia Resort - Fifth Settlement - New Cairo - Egypt",
  },
  footer: {
    rights: "ZRS Hubtech",
  },
};

export type Lang = "ar" | "en";

export const content: Record<Lang, Content> = { ar, en };
